import { RootGizmo } from '../../../gizmos';
import { configV2ToV3 } from '../../../gizmos/utils';
import { IFormGizmoV2, IRootGizmoData, TGetInfoCB } from '../../../types';

interface IParams {
  form: IFormGizmoV2;
  filledForm: IRootGizmoData;
  rootGizmo?: RootGizmo;
}

/**
 * Simulate the gizmo callbacks object in order to avoid instantiating a gizmo, this simulated
 * object will provide only the needed methods so Flux can fulfill its job
 *
 * @param {IFormGizmoV2} form form configuration
 * @param {IRootGizmoData} form filled form data
 * @returns
 */
function simulateCallbacksForFilledForm({
  form,
  filledForm,
  rootGizmo,
}: IParams): any {
  // In here we're creating the getInfoCB which will respond with information from the
  // current filled form, we're doing this in order to use influx function
  const getInfoCB: TGetInfoCB = ({ type, fid, uid }) => {
    if (type === 'data' && fid && filledForm.d) {
      return filledForm.d[fid];
    } else if (type === 'data' && uid && filledForm.d) {
      const question = form.questions.find(q => q.uid === uid);

      if (question) {
        return filledForm.d[question.f_id];
      }
    } else if (type === 'gizmo' && uid && !rootGizmo) {
      const gizmoConfig = form.questions.find(q => q.uid === uid);

      if (gizmoConfig) {
        // In here we're returning an object with the only method needed by Flux, specifically by
        // the influx function
        const dummyGizmo: any = {
          getConfig: () =>
            configV2ToV3({
              config: gizmoConfig,
            }),
        };
        return dummyGizmo;
      }
    } else if (type === 'gizmo' && uid && rootGizmo) {
      const gizmo = rootGizmo.findGizmo({ uid });

      if (gizmo) {
        return gizmo;
      }
    }

    return undefined;
  };
  const callbacks: any = {
    getInfoCB,
  };

  return callbacks;
}

export default simulateCallbacksForFilledForm;
